import styled from "@emotion/styled";
import React from "react";
import QuestionIcon from "@ecologi/assets/icons/UnsureWhatToFund/question.svg";
import { Typography } from "../Typography";

const BannerContainer = styled.div`
  padding: 16px;

  @media ${({ theme }) => theme.bp.wideDesktopUp} {
    padding: 24px;
  }
`;

const Wrapper = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.jungleLighter};
  border-radius: 12px;
  padding: 16px 24px;
  gap: 16px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.jungleLight};

    [data-pill-label] {
      background-color: ${({ theme }) => theme.colors.forestDark};
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.forest};
    outline-offset: 2px;
  }

  @media ${({ theme }) => theme.bp.tabletDown} {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.forest};

  svg {
    width: 40px;
    height: 40px;
  }
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const QuestionText = styled(Typography)`
  color: ${({ theme }) => theme.colors.forest};
`;

const PillLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.colors.forest};
  color: ${({ theme }) => theme.colors.snowdrop};
  border-radius: 100px;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.2s ease;
`;

type UnsureWhatToFundCardProps = {
  onClick: () => void;
};

export const UnsureWhatToFundCard = ({
  onClick,
}: UnsureWhatToFundCardProps) => {
  return (
    <BannerContainer>
      <Wrapper
        onClick={onClick}
        data-testid="unsure-what-to-fund-card"
        aria-label="Help me decide what to fund"
      >
        <LeftContent>
          <IconWrapper>
            <QuestionIcon />
          </IconWrapper>
          <QuestionText use="componentTitle">Unsure what to fund?</QuestionText>
        </LeftContent>
        <PillLabel data-pill-label aria-hidden="true">
          Help me decide
        </PillLabel>
      </Wrapper>
    </BannerContainer>
  );
};
